<template>
  <VueSelect
    multiple
    v-model="current"
    :filterable="false"
    :options="options"
    :placeholder="placeholder"
    :reduce="row => row._id"
    label="name"
    @input="emitInput"
  >
    <template v-slot:no-options="{ search, searching }">
      <template v-if="searching">
        Nenhum item encontrado: <em>{{ search }}</em>.
      </template>
      <em v-else style="opacity: 0.5;">Digite para procurar...</em>
    </template>
  </VueSelect>
</template>

<script>
import { VueSelect } from 'vue-select'
import { H } from 'hennig-common'

export default {
  name: 'EventGroupMultiselect',
  components: { VueSelect },
  props: {
    value: {},
    initPlaceholder: { String, default: '' }
  },
  data () {
    return {
      current: '',
      placeholder: '',
      options: []
    }
  },
  watch: {
    value (v) {
      this.current = v
    }
  },
  mounted () {
    this.placeholder = this.initPlaceholder
  },
  methods: {
    emitInput (v) {
      this.$emit('input', v)

      if (this.options.length) {
        for (const row of this.options) {
          if (row._id === v) {
            this.$emit('row', row)
            return
          }
        }
      }

      this.$emit('row', {})
    },
    getValue () {
      return this.current
    },
    setValue (v) {
      this.fetchOptions(v || '', (loading) => {
        if (loading === false) {
          this.current = v
        }
      })
    },
    fetchOptions (search, loading) {
      search = search || this.current || ''
      loading && loading(true)
      this.options = []
      H.rpc('EventGroup', 'lookup', [search], r => {
        if (r) {
          this.options = r
        }

        loading && loading(false)
      })
    }
  }
}
</script>
